import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRateLots = (resource, id) => {
  return axios.get(`/api/${resource}/${id}/rates/lots`);
};

export const useRateLots = (resource, id, options = {}) => {
  return useQuery(`${resource}-${id}-rates-lots`, () => getRateLots(resource, id), {
    //@ts-ignore
    initialData: { data: { data: [] } },
    select: ({ data }) => data.data,
    ...options,
  });
};
